// IMPORTS
import { onMounted, computed } from 'vue'
import widgetHeader from "./widgetHeader";
import widgetContent from "./widgetContent";
import widgetFooter from "./widgetFooter";
import countDown from "../counter/countDown";
import widgetButtonRow from "./widgetButtonRow";
import widgetContentBox from './widgetContentBox';
import sponsorBox from '../sponsors/sponsorBox';
import resultsBox from '../ecResults/components/resultsBox';
import { store } from "../../store/store";

import widgetBoxStyles from "../../css/widgetBox.scss";

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'WidgetBox',

    /* Any imported component for this file needs to be listed here */
    components: {
        widgetHeader,
        widgetContent,
        widgetFooter,
        countDown,
        widgetButtonRow,
        widgetContentBox,
        sponsorBox,
        resultsBox
    },

    /* Declare any expected props here */
    props: {
        sampleProp: {
            type: String,
            required: false,
            default: ''
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        onMounted(() => {
            store.bootstrapApp();
        });

        const widgetSettings = computed(() => {
            return store.widget.state.getWidgetSettings();
        });

        const currentTime = computed(() => {
            return store.state.getCurrentTime();
        });

        const widgetStep = computed(() => {
            return store.widget.state.getCurrentWidgetStep();
            // return store.widget.determineWidgetStep();
        });


        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            widgetSettings,
            currentTime,
            widgetStep
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <!-- THIS WIDGET WILL NOT SHOW IF WIDGETSTEP ISN'T VALID -->
        <div class="cfm_ec_widget_box"
        v-if="widgetSettings.length > 0 && currentTime.dateTime && widgetStep.maincontent"
        >
            
            <!--  WIDGET HEADER -->
            <widget-header
            :label="widgetStep.headertext"
            :showSponsor="widgetStep.showsponsor"
            :sponsorLogo="widgetStep.sponsorsquarelogourl"
            :sponsorLink="widgetStep.sponsorlinkurl"
            :sponsorBgColor="widgetStep.sponsorsquarelogobgcolor"
            ></widget-header>

            <!-- WIDGET MAIN CONTENT -->
            <widget-content>

                <!-- OUTPUT IF WIDGET STEP IS FOUND AND RELEVANT -->
                <!-- LEAVING THIS HERE (IT'S REDUNDANT) FOR FUTURE IF DESIRING AN "ELSE" FOR DEFAULT CONTENT -->
                <template
                v-if="widgetStep.maincontent"
                >

                    <!-- COUNTDOWN WIDGET -->
                    <count-down
                    v-if="widgetStep.maincontent.toLowerCase().trim() == 'countdown'"
                    :targetTime="widgetStep.stop"
                    ></count-down>

                    <!-- RESULTS BOX -->
                    <results-box
                    v-if="widgetStep.maincontent.toLowerCase().trim() == 'results'"
                    ></results-box>

                    <!-- TEXT CONTENT BOX -->
                    <widget-content-box
                    v-if="widgetStep.maincontent.toLowerCase().trim() != 'countdown' && widgetStep.maincontent.toLowerCase().trim() != 'results'"
                    >
                        {{ widgetStep.maincontent }}
                    </widget-content-box>

                    <!-- BUTTONS ROWS -->
                    <widget-button-row
                    v-if="widgetStep.buttons.length > 0"
                    :buttons="widgetStep.buttons"
                    ></widget-button-row>

                </template>

            </widget-content>

            <!-- WIDGET FOOTER -->
            <widget-footer
            :content="widgetStep.footertext"
            ></widget-footer>

        </div>

        <!-- SPONSOR BOX -->
        <sponsor-box
        v-if="widgetSettings.length > 0 && currentTime.dateTime && widgetStep.showsponsor.toUpperCase() == 'TRUE'"
        :prefix="widgetStep.sponsorprefix"
        :logo="widgetStep.sponsorlogourl"
        :label="widgetStep.sponsorlabel"
        :link="widgetStep.sponsorlinkurl"
        ></sponsor-box>
    `,
}